import { render, staticRenderFns } from "./TemplateChartYCS.vue?vue&type=template&id=3a88d0c0&scoped=true&"
import script from "./TemplateChartYCS.vue?vue&type=script&lang=js&"
export * from "./TemplateChartYCS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a88d0c0",
  null
  
)

export default component.exports